import {Component, input} from '@angular/core';
import {MdbDropdownModule} from "mdb-angular-ui-kit/dropdown";
import {TranslateModule} from "@ngx-translate/core";
import { NgOptimizedImage } from "@angular/common";
import {LanguageService} from "../../../services/resources/language.service";
import {environment} from "../../../../environments/environment";
import {LanguagePipe} from "../../../pipes/language.pipe";
import {LanguageModel} from "../../../models/resources/language.model";
import {AuthService} from "../../../services/auth/auth.service";

@Component({
  selector: 'app-language-select',
  imports: [
    MdbDropdownModule,
    TranslateModule,
    NgOptimizedImage,
    LanguagePipe
],
  templateUrl: './language-select.component.html',
  standalone: true,
  styleUrl: './language-select.component.scss'
})
export class LanguageSelectComponent {
  showNames = input(false)

  constructor(public languageService: LanguageService,
              private authService: AuthService,) {
  }

  changeLanguage(language: LanguageModel) {
    this.languageService.activeLanguage.set(language)
    if(this.authService.user())
      this.authService.updateLanguage(language.id).subscribe()
  }

  protected readonly environment = environment;
}
